var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.3877C9.48255 16.3877 9.06255 15.9677 9.06255 15.4502C9.06255 14.9327 9.48255 14.5127 10 14.5127C10.5175 14.5127 10.9375 14.9327 10.9375 15.4502C10.9375 15.9677 10.5175 16.3877 10 16.3877ZM9.29692 7.63773H10.7032V13.2627H9.29692V7.63773ZM10.0013 3.99461H9.9988L2.90567 17.6359C2.90567 17.6359 2.90567 17.6377 2.90692 17.6377H17.0932C17.0944 17.6377 17.0944 17.6359 17.0944 17.6359L10.0013 3.99461Z",
    fill: "#F67E7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90613 17.6378H17.093L17.0943 17.6359L10.0005 3.99467H9.998L2.90488 17.6359C2.90488 17.6359 2.90488 17.6378 2.90613 17.6378ZM18.1243 18.8878H1.87425C1.65613 18.8878 1.45363 18.774 1.33988 18.5872C1.22675 18.4003 1.21925 18.1684 1.31988 17.9747L9.44488 2.34967C9.67863 1.90029 10.3205 1.90029 10.5543 2.34967L18.6793 17.9747C18.7799 18.1684 18.7718 18.4003 18.6586 18.5872C18.5455 18.774 18.343 18.8878 18.1243 18.8878Z",
    fill: "#F67E7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.e35d43e4a0892689144ba717d9788641.svg";
export { ForwardRef as ReactComponent };